import React from "react";
import { Button, Modal } from "react-bootstrap";
import { toast, Bounce } from "react-toastify";
import { apiRequest } from "../../utils/utils";

const DeleteAccount = (props) => {
  const { data } = props;

  console.log(data, 234243242342);

  const handleSubmit = async () => {
    // Process the data or perform any actions
    const postData = {
      product_key: data && data.product,
      app_token: data && data.customer_id,
      studio_id: data && data.customer_id,
      user_id: data && data.user_uuid,
      is_live: data && data.isLive,
    };
    let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/delete";
    let responseData;
    try {
      responseData = await apiRequest(crmStagingUrl, "POST", postData);
      //console.log("Response:", responseData);
    } catch (error) {
      console.error("Error:", error);
    }

    if (responseData && responseData.status == "OK") {
      props.syncFilterWithAggrid();

      toast.success(responseData.msg, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } else {
      const errorMessage =
        responseData && responseData.msg
          ? responseData.msg
          : "An error occurred";

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      // Action to take if user clicks "Cancel" or closes the dialog
      console.warn("Something went wrong to move demo.");
    }
  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header closeButton>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{data && data.confirmText}</h4>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={props.close}
          >
            Close
          </Button>
          <Button type="button" variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAccount;



// WEBPACK FOOTER //
// ./src/components/childcomponents/DeleteAccount.js